<template>
  <div class="base-tabs">
    <div class="m-container base-tabs-list">
      <label
        class="base-tabs-tab"
        :class="{
          '-active': option.value === modelValue,
        }"
        v-for="option in options"
        :key="option.value"
      >
        <input
          type="radio"
          name="radio"
          :value="option.value"
          :checked="option.value === modelValue"
          @change="$emit('update:modelValue', option.value)"
        >
        {{ option.label }}
      </label>
    </div>
  </div>
</template>

<script setup>
defineProps({
  modelValue: {
    type: String,
    default: null,
  },
  options: {
    type: Array,
    default: null,
  },
});
</script>

<style scoped>
.base-tabs {
  border-bottom: 1px solid var(--blue);
}

.base-tabs-list {
  display: flex;
  gap: 8px;
}

.base-tabs-tab {
  display: block;
  cursor: pointer;
  text-align: center;
  padding: 8px;
  flex: 1;
  font-weight: 700;
  border-radius: var(--border-radius-sm) var(--border-radius-sm) 0 0;
  font-size: var(--font-size-100);
  margin-bottom: -1px;

  color: var(--gray-600);
  border: 1px solid var(--gray-300);
  & input {
    display: none;
  }
  &:not(.-active) {
    border-bottom-color: var(--blue);
  }
  &.-active {
    background-color: var(--blue-5);
    border-color: var(--blue);
    border-bottom-color: var(--blue-5);
    color: var(--blue);
  }
}
</style>
